import { render } from "./BeforeLoginLayout.vue?vue&type=template&id=67f077e0&scoped=true&ts=true"
import script from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"
export * from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"

import "./BeforeLoginLayout.vue?vue&type=style&index=0&id=67f077e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f077e0"]])

export default __exports__